import BasketItemsSFC from "./BasketItems.vue";
export const BasketItems = BasketItemsSFC;
